import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
import { useForm } from 'react-hook-form'

import { urlPath } from '@/utils/lpPath'

import ContactCompanyForm from './ContactCompanyForm'
import ContactPersonalForm from './ContactPersonalForm'

export type ContactParams = {
  otoiawasesyubetsu_atsougi: string // お問い合わせ種別
  company: string // 企業名
  firstname: string // 担当者
  lastname: string // 担当者
  email: string
  phone: string
  syozaichi: string
  toiawasenaiyou: string
  identification_label: string
}

type Props = {
  values: ContactParams
  toConfirm: (values: ContactParams) => void
  targetValue: string
  setTargetValue: (targetValue: string) => void
}

type Target = '法人のお客様' | '個人のお客様'

const targets: Target[] = ['法人のお客様', '個人のお客様']

export const ContactTypes = [
  '@葬儀サービスについて',
  '契約・申込みについて',
  'お香典（喪主様・参列者様）',
  'その他お問い合わせ',
]

const ContactContainer: React.FC<Props> = ({ targetValue, setTargetValue, values, toConfirm }) => {
  const { register, handleSubmit, formState } = useForm<ContactParams>({
    defaultValues: values,
  })

  const onSubmit = handleSubmit((ContactParams) => {
    toConfirm({
      ...ContactParams,
      identification_label: targetValue === '個人のお客様' ? '個人' : '法人',
    })
  })
  return (
    <>
      <main>
        <div className="contact">
          <div id="contactNavbarPC" className="flex justify-between sp:hidden">
            <Link href={urlPath.top}>
              <a>
                <Image
                  layout="raw"
                  className=""
                  src="/images/logo/atsougi_logo.png"
                  alt="logo"
                  width="120"
                  height="55"
                />
              </a>
            </Link>
          </div>
          <div id="contactNavbarSP" className="flex justify-between pc:hidden">
            <Link href={urlPath.top}>
              <a>
                <Image
                  layout="raw"
                  className=""
                  src="/images/logo/atsougi_logo.png"
                  alt="logo"
                  width="105"
                  height="48"
                />
              </a>
            </Link>
          </div>
          <div className="body">
            <div className="section">
              <div className="faqCaption mb-16">
                <p className="caption">お問い合わせ</p>
              </div>
              <form onSubmit={onSubmit}>
                <div className="mx-auto mb-8 flex justify-center">
                  {targets.map((t) => (
                    <p className="text-center  mod-form-radio" key={t}>
                      <label className={`contactSwitch ${t === targetValue && 'checked'} mx-3`}>
                        <input
                          className="hidden"
                          checked={t === targetValue}
                          type="radio"
                          name="target"
                          value={t}
                          onChange={(e) => {
                            setTargetValue(e.target.value)
                          }}
                        />
                        <span>{t}</span>
                      </label>
                    </p>
                  ))}
                </div>
                <ul className="contactForm">
                  {targetValue === '個人のお客様' && (
                    <ContactPersonalForm register={register} formState={formState} />
                  )}
                  {targetValue === '法人のお客様' && (
                    <ContactCompanyForm register={register} formState={formState} />
                  )}
                </ul>
                <div className="mt-8 mb-12">
                  「
                  <a href={urlPath.privacy} target="brank" className="link">
                    プライバシーポリシー{' '}
                    <Image
                      src="/images/linkIcon.png"
                      alt="link"
                      width={16}
                      height={16}
                      layout="raw"
                    />
                  </a>
                  」 をご確認、ご同意の上「入力内容を確認する」ボタンを押してください。
                </div>
                <div className="text-center">
                  <button type="submit" className="contactSubmit m-auto">
                    入力内容を確認する
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </main>
    </>
  )
}
export default ContactContainer
